import axios from '../../../axiosConfig';

const BASE = '/utilities/tasks';

export const tasksService = {
  async list(params = {}) {
    const { data } = await axios.get(BASE, { params });
    return data?.tasks || [];
  },

  async create(payload) {
    const { data } = await axios.post(BASE, payload);
    return data?.task;
  },

  async get(id) {
    const { data } = await axios.get(`${BASE}/${id}`);
    return data?.task;
  },

  async update(id, patch) {
    const { data } = await axios.patch(`${BASE}/${id}`, patch);
    return data?.task;
  },

  async toggle(id) {
    const { data } = await axios.post(`${BASE}/${id}/toggle`);
    return data?.task;
  },

  async remove(id) {
    await axios.delete(`${BASE}/${id}`);
  },

  // ── Reminders ────────────────────────────────────────────────────
  async addReminder(taskId, payload) {
    const { data } = await axios.post(`${BASE}/${taskId}/reminders`, payload);
    return data?.reminder;
  },

  async updateReminder(taskId, reminderId, payload) {
    const { data } = await axios.patch(`${BASE}/${taskId}/reminders/${reminderId}`, payload);
    return data?.reminder;
  },

  async removeReminder(taskId, reminderId) {
    await axios.delete(`${BASE}/${taskId}/reminders/${reminderId}`);
  }
};
